// extracted by mini-css-extract-plugin
module.exports = {"title":"Content068_title__C7wJv","content":"Content068_content__YWdzo","narrow":"Content068_narrow__lc_F_","wrapper":"Content068_wrapper__UiPyE"};